


















































import Vue from 'vue';
import {Component, Prop} from 'vue-property-decorator';
// @ts-ignore
import store from "../../store";
// @ts-ignore
import Tools from "../../helpers/Tools";
import MessageHelper from "../../helpers/MessageHelper";
import {CurrentGame, GameSettings, Player} from "../../../types";
import DraggableHtmlElement from "../../libs/draggable-html-element/DraggableHtmlElement";

const MESSAGE_STATUS_PUBLIC = 1;
const MESSAGE_STATUS_HIDDEN = 2;

@Component({
    components: {},
    props: {}
})

export default class DiceGenerator extends Vue {
    private diceTypesArray: Array<string> = ['d4', 'd6', 'd8', 'd10', 'd12', 'd20', 'd100'];
    private diceValues: Array<{type: string, count: number}> = [{type: 'd6', count: 1}];
    private newMessageVisibleFor: Array<string> = [];
    private isAnonymous: boolean = false;
    private status: number = 0;
    private panelInstance: DraggableHtmlElement|null = null;

    mounted(): void
    {
        this.bindEvents();
        /*this.panelInstance = new DraggableHtmlElement(this.$refs.panel as HTMLElement);
        (this.$refs.panel as HTMLElement).addEventListener('dragEnd', this.dragEnd);*/
    }

    beforeDestroy(): void
    {
        this.unbindEvents();
    }

    /**
     * ID игрока
     */
    private get playerId(): string
    {
        return store.getters.getPlayerId;
    }

    /**
     * Данные игроков
     */
    private get players(): Array<Player>
    {
        return store.getters.getPlayers;
    }

    /**
     * Текущая игра
     */
    private get currentActivity(): CurrentGame
    {
        return store.getters.getCurrentActivity;
    }

    /**
     * Настройки текущей игры
     */
    private get currentActivitySettings(): null|GameSettings
    {
        if (!this.currentActivity) {
            return null;
        }
        return this.currentActivity.settings;
    }

    /**
     * Разрешить анонимный бросок кубика
     */
    private get allowAnonymouslyDice(): boolean
    {
        if (!this.currentActivitySettings) {
        return true;
    }
        return this.currentActivitySettings.canDiceAnonymously;
    }

    private get allowThrow(): boolean {
        if (!this.currentActivitySettings) {
            return true;
        }
        return this.currentActivitySettings.canViewDice;
    }

    /**
     * Исключить элементы с таким же типом
     */
    private excludeSameType(type: string): void
    {
        this.diceValues.forEach((value: any, index) => {
            if (value.type === type) {
                this.diceValues.splice(index, 1);
            }
        });
    }

    /**
     * Изменить видимость нового сообщения для конкретных ситов
     * @param playerId - ID игрока
     */
    private toggleNewMessageVisibilityFor(playerId: string) {
        this.newMessageVisibleFor = Tools.toggleArrayElement(this.newMessageVisibleFor, playerId);
    }

    /**
     * Изменить видимость нового сообщения для всех ситов
     */
    private toggleNewMessageVisibilityAll(): void
    {

        if (this.newMessageVisibleFor.length > 1) {
            // Если видимо для кого-то кроме автора - выключаем видимость для всех, кроме автора
            this.newMessageVisibleFor = [this.playerId];
        } else {
            // Если видимо только автору - включаем видимость для всех
            const players = this.players;
            this.newMessageVisibleFor = players.map((el) => {
                return el.id;
            });
        }
    }

    /**
     * Изменить анонимность сообщения
     * @param isAnonymous
     */
    private toggleAnonymity(isAnonymous: boolean): void
    {
        this.isAnonymous = isAnonymous;
    }

    /**
     * Обычный выбор
     */
    private onClick(type: string, count: number): void
    {
        this.diceValues = [];
        this.diceValues.push({
            type: type,
            count: count,
        });
    }

    /**
     * Мультивыбор
     */
    private onClickWithShift(type: string, count: number): void
    {
        this.excludeSameType(type);
        this.diceValues.push({
            type: type,
            count: count,
        });
    }

    /**
     * Элемент выбран
     */
    private isSelectedItem(type: string, count: number): boolean
    {
        let selected = false;
        this.diceValues.forEach((item) => {
            if (item.type === type && item.count === count) {
                selected = true;
            }
        });
        return selected;
    }

    /**
     * Тип выбран
     */
    private isSelectedType(type: string): boolean
    {
        let selected = false;
        this.diceValues.forEach((item) => {
            if (item.type === type) {
                selected = true;
            }
        });
        return selected;
    }

    private bindEvents(): void
    {
        $(document).on('keyup', this.onHotKeys);
    }

    private unbindEvents(): void
    {
        $(document).off('keyup', this.onHotKeys);
    }

    /**
     * Обработка хоткеев
     */
    private onHotKeys(e: any): void
    {
        if (store.getters.getPainterEditMode) {
            return;
        }
        if (this.currentActivitySettings && !this.allowThrow) {
            return;
        }
        // бросаем кубики при нажатии на R в любое время
        if (e.keyCode === 82) {
            const focused = Tools.userFocusedOnInput();
            if (!focused) {
                this.roll();
            }
        }
    }

    private generateSvgIcon(type: string): string
    {
        // @ts-ignore
        const typeNumber = type.slice('1');
        return `#ic_dice${typeNumber}`;
    }

    private generateSvgIconNotFilled(type: string): string
    {
        // @ts-ignore
        const typeNumber = type.slice('1');
        return `#ic_dice${typeNumber}_black`;
    }

    /**
     * Бросок дайса
     */
    private roll(): void
    {
        let values = this.diceValues;

        // по умолчанию, если ничего не выбрано, но вызвали по хоткею
        if (!values.length) {
            values = [{
                type: 'd6',
                count: 1
            }];
        }

        let command = '/';

        values.forEach((item) => {
            for (let i = 0; i < item.count; i++) {
                command += item.type + ' ';
            }
        });

        MessageHelper.sendPlaySoundMessage('dice');

        this.status = MESSAGE_STATUS_PUBLIC;

        if (this.newMessageVisibleFor.length > 0) {
            this.status = MESSAGE_STATUS_HIDDEN;
        }

        const data = {
            text: command,
            status: this.status,
            visibleFor: this.newMessageVisibleFor,
            anonymous: this.isAnonymous,
        };
        MessageHelper.sendMessage('chatMessage', data);
        this.$emit('send-dice-command');
    }

    /**
     * Закончили перетаскивание
     * @param e
     * @private
     */
    private dragEnd(e: any): void
    {
        console.log(e.detail);
    }
}
